import React, { createContext, useState } from 'react';
import PropTypes from "prop-types"
export const CompanyLevelAttendanceContext  = createContext();

export const AttendanceData = ({ children }) => {
    const [attendanceData, setAttendanceData] = useState(null);
    return (
        <CompanyLevelAttendanceContext.Provider value={{attendanceData, setAttendanceData}}>
            {children}
        </CompanyLevelAttendanceContext.Provider>
    );
};

AttendanceData.propTypes = {
    children: PropTypes.node.isRequired
};